
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "ForrestClassification",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/ForrestClassification.vue